import { DeliveryItemList as BaseItemList } from '../DeliveryItemList';
import { useDeliveryContext } from './DeliveryContext';
import { DeliveryItem } from '../../types';

export interface ItemListProps {
    label: string;
}

export const ItemList = <T extends DeliveryItem, P>({
    label,
}: ItemListProps) => {
    const { validItems, selectedIds, toggleSelection } = useDeliveryContext<
        T,
        P
    >();

    return (
        <BaseItemList
            items={validItems}
            selectedIds={selectedIds}
            onToggle={toggleSelection}
            label={label}
        />
    );
};
